/** Het Trigion-schild: beveiliging, met de T uitgespaard. */
export function LogoMark({ className = 'h-6 w-6' }: { className?: string }) {
  return (
    <svg viewBox="14 8 36 47" className={className} aria-hidden>
      <path d="M32 10 48 15.5V30c0 10.5-6.8 18.6-16 23-9.2-4.4-16-12.5-16-23V15.5Z" fill="#F5B841" />
      <path d="M24 21h16v4.5h-5.75V42h-4.5V25.5H24Z" fill="#0E1116" />
    </svg>
  );
}
